module.exports = __webpack_public_path__ + "img/tarun.fb4598a1.jpeg";